<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de moedas</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="Moeda.moeId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="Moeda.moeNome"
                                        label="Nome" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="Moeda.moeAtivo" label="Ativo" :items="StatusAtivo"
                                        item-title="nome" item-value="moeAtivo" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4" v-if="Idiomas!=''">
                                    <v-select v-model="Moeda.idiId" label="Idiomas" :items="Idiomas"
                                        item-title="idiNome" item-value="idiId" variant="underlined">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="Moeda.moeId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="Moedas" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-moeAtivo="item">
                            <span>{{ item.moeAtivo ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroMoedasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        Moeda: {
            moeId: 0,
            moeNome: '',
            moeAtivo: '',
            idiId: '',
        },
        Moedas: [],
        StatusAtivo: [{ nome: "Sim", moeAtivo: true }, { nome: "Não", moeAtivo: false }],
        headers: [
            { text: "Id", value: "moeId", sortable: true, },
            { text: "Nome", value: "moeNome", sortable: true, },
            { text: "Ativo", value: "moeAtivo", sortable: true, },
            { text: "Idioma", value: "cadIdiomas.idiNome", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        selectedIdiomas:null,
        Idiomas:[],
        searchValue: '',
    }),
    methods: {
        Limpar() {
            this.Moeda.moeId = 0;
            this.Moeda.moeNome = '';
            this.Moeda.moeAtivo = '';
            this.Moeda.idiId = '';
            this.selectedIdiomas = null;
            this.Get();
        },
        Add() {
            if (this.Moeda.moeNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Moeda.idiId === ''){
                this.$mensagemAviso("Idioma Obrigatório.")
            }
            else {
                this.Moeda.CadIdiomas = { idiId: this.Moeda.idiId};
                if (this.Moeda.moeAtivo === "" || this.Moeda.moeAtivo === null){
                            this.Moeda.moeAtivo = true;
                }
                axios.post(`/Process/CadMoedas/Add`, this.Moeda)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.Moeda.moeNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Moeda.idiId === ''){
                this.$mensagemAviso("Idioma Obrigatório.")
            }
            else {
                this.Moeda.CadIdiomas = { idiId: this.Moeda.idiId};
                if (this.Moeda.moeAtivo === "" || this.Moeda.moeAtivo === null){
                            this.Moeda.moeAtivo = true;
                }
                axios.put(`/Process/CadMoedas/Update`, this.Moeda)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.Moeda = item;
            this.Moeda.idiId = item.cadIdiomas.idiId
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.moeId;
                axios.delete(`/Process/CadMoedas/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`/Process/CadMoedas/GetAll`)
                .then(response => {
                    this.Moedas = response.data;
                });
        }
    },
    created() {
        this.Get();

        axios.get(`/Process/CadIdiomas/GetAll`)
                .then(response => {
                    this.Idiomas = response.data.filter(x => x.idiAtivo).sort((a, b) => {
                                                                                    const nomeA = a.idiNome || ""; 
                                                                                    const nomeB = b.idiNome || ""; 
                                                                                    return nomeA.localeCompare(nomeB);
                                                                                    });
                });
    },
}
</script>

<style></style>
